import React from 'react';
import { Eye, ArrowLeft, ChevronRight, Upload } from "lucide-react";
import { useNavigate } from 'react-router-dom';

const AudioBuzzManagement = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/Management');
  };

  const handleReviewRecord = () => {
    navigate('/audioReviewRecord');
  };

  const handleImportRecord = () => {
    navigate('/importData');
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white p-4 md:p-6 flex flex-col mb-0">
      <div className="flex items-center mb-10">
        <button
          type="button"
          className="mr-3 text-white hover:text-gray-300"
          onClick={handleBackClick}
        >
          <ArrowLeft size={24} />
        </button>

        <h1 className="text-xl md:text-2xl font-bold">
          Audio Buzz Management
        </h1>
      </div>

      <div className="space-y-10 md:space-y-15 flex-1 mt-10">
        {/* Review Record card */}
        <div className="flex justify-center">
          <button
            type="button"
            onClick={handleReviewRecord}
            className="bg-gray-800 rounded-lg p-6
                       flex items-center justify-between
                       w-[300px] sm:w-[380px] md:w-[600px]
                       h-[160px] md:h-[250px] border border-gray-600
                       hover:border-blue-400 hover:bg-gray-700
                       transition-colors cursor-pointer text-left"
          >
            <div className="flex items-center">
              <div className="mr-4 md:mr-10 md:ml-10 p-1 rounded-full transform -translate-x-3 md:translate-x-0">
                <Eye className="w-7 h-7 md:w-10 md:h-10 text-blue-500" />
              </div>
              <div className="text-left ml-[-15px] md:ml-0">
                <h2 className="text-xl md:text-2xl font-semibold text-white max-w-[160px] md:max-w-none">
                  Review Record and Download
                </h2>
                <p className="text-sm md:text-base text-gray-300 mt-1 max-w-[160px] md:max-w-none">
                  Review and download audio recordings
                </p>
              </div>
            </div>
            <span className="text-gray-400 hover:text-blue-300 text-sm md:text-base font-medium ml-4 md:mr-5 transform translate-x-2 md:translate-x-0">
              <ChevronRight className="w-6 h-6 md:w-9 md:h-9" />
            </span>
          </button>
        </div>

        {/* Import Record card */}
        <div className="flex justify-center">
          <button
            type="button"
            onClick={handleImportRecord}
            className="bg-gray-800 rounded-lg p-6
                       flex items-center justify-between
                       w-[300px] sm:w-[380px] md:w-[600px]
                       h-[160px] md:h-[250px] border border-gray-600
                       hover:border-blue-400 hover:bg-gray-700
                       transition-colors cursor-pointer text-left"
          >
            <div className="flex items-center">
              <div className="mr-4 md:mr-10 md:ml-10 p-1 rounded-full transform -translate-x-3 md:translate-x-0">
                <Upload className="w-7 h-7 md:w-10 md:h-10 text-blue-500" />
              </div>
              <div className="text-left ml-[-15px] md:ml-0">
                <h2 className="text-xl md:text-2xl font-semibold text-white max-w-[160px] md:max-w-none">
                  Import Record By Expert
                </h2>
                <p className="text-sm md:text-base text-gray-300 mt-1 max-w-[160px] md:max-w-none">
                  Import audio recordings from experts
                </p>
              </div>
            </div>
            <span className="text-gray-400 hover:text-blue-300 text-sm md:text-base font-medium ml-4 md:mr-5 transform translate-x-2 md:translate-x-0">
              <ChevronRight className="w-6 h-6 md:w-9 md:h-9" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AudioBuzzManagement;
